import { NavLink } from 'fluxible-router';
import * as React from 'react';
import styles from './styles.module.styl';
export var JobCard = function (props) {
    var title = props.title, description = props.description, imageUrl = props.imageUrl, articles = props.articles;
    return (React.createElement("div", { className: "".concat(styles.jobCard) },
        React.createElement("div", { className: "".concat(styles.jobCardContainer, " container") },
            React.createElement("div", { className: "".concat(styles.jobCardLogo, " col-xs-4") },
                React.createElement("img", { src: imageUrl })),
            React.createElement("div", { className: "".concat(styles.jobCardMain, " col-xs-8") },
                React.createElement("h3", null, title),
                React.createElement("p", null, description),
                React.createElement("ul", { className: styles.jobCardArticles }, articles.map(function (article) { return (React.createElement("li", { key: article.url },
                    React.createElement(NavLink, { href: article.url, followLink: article.forceFullReload }, article.title))); }))))));
};
